import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { isLocale, type Locale } from './content'

export function useLocale(): Locale {
  const { locale } = useParams()
  return isLocale(locale) ? locale : 'fr'
}

// Pendant le pré-rendu (build, pas de navigateur), le titre et la description de la page sont notés ici, puis écrits
// dans le HTML envoyé à Google par scripts/prerender.mjs. Dans le navigateur, l'effet ci-dessous fait le même travail.
// Les données structurées (JSON-LD) de la page sont notées de la même façon, et écrites dans le HTML au build seulement.
export const ssrMeta: { title?: string; description?: string; jsonld?: object[] } = {}

// Le nom de la marque s'ajoute au titre seulement s'il reste court (Google coupe vers 60 signes).
const titreComplet = (title: string) => title.length <= 46 ? `${title} — COGETRANS` : title

export function usePageMeta(title: string, description: string, locale: Locale, jsonld?: object[]) {
  if (typeof document === 'undefined') {
    ssrMeta.title = titreComplet(title)
    ssrMeta.description = description
    ssrMeta.jsonld = jsonld
  }
  useEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr'
    document.title = titreComplet(title)
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'description'
      document.head.appendChild(meta)
    }
    meta.content = description
  }, [title, description, locale])
}

export function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

export function switchLocalePath(pathname: string, next: Locale) {
  const parts = pathname.split('/').filter(Boolean)
  if (parts[0] === 'fr' || parts[0] === 'ar') parts[0] = next
  else parts.unshift(next)
  return `/${parts.join('/')}`
}
